import { render, staticRenderFns } from "./VideoPlayerWithPagination.vue?vue&type=template&id=1cfddc3c&scoped=true"
import script from "./VideoPlayerWithPagination.vue?vue&type=script&lang=js"
export * from "./VideoPlayerWithPagination.vue?vue&type=script&lang=js"
import style0 from "./VideoPlayerWithPagination.vue?vue&type=style&index=0&id=1cfddc3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfddc3c",
  null
  
)

export default component.exports